"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientRender = clientRender;
exports.serverRender = serverRender;
exports.renderAllBanners = renderAllBanners;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _compat = require("compat");

var _mailchimpSignup = require("mailchimp-signup");

function clientRender(node) {
  _reactDom.default.render(_react.default.createElement(EmailSignupBanner, null), node);
}

function serverRender() {
  return require('exports').Layouts.MainLayout.prototype.getCtaBanner();
  return "\n\t\t<div component='EmailSignup'>".concat(_server.default.renderToString(_react.default.createElement(EmailSignupBanner, null)), "</div>\n\t\t<script>require('email-signup').renderAllBanners()</script>\n\t");
}

var once = false;

function renderAllBanners() {
  if (once) return;
  once = true;
  document.querySelectorAll('[component=EmailSignup]').forEach(function (node) {
    return clientRender(node);
  });
}

var EmailSignupBanner =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EmailSignupBanner, _Component);

  function EmailSignupBanner() {
    babelHelpers.classCallCheck(this, EmailSignupBanner);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(EmailSignupBanner).apply(this, arguments));
  }

  babelHelpers.createClass(EmailSignupBanner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "email-signup-banner"
      }, _react.default.createElement("p", null, _react.default.createElement("img", {
        className: "icon-email-signup",
        src: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/icon-email-signup.png"
      }), "Get seasonal buying advice and promotions in your inbox."), _react.default.createElement("button", {
        className: "btn btn-secondary white",
        onClick: _mailchimpSignup.show
      }, "Sign Up"));
    }
  }]);
  return EmailSignupBanner;
}(_react.Component);

exports.default = EmailSignupBanner;